<!-- @format -->
<ng-template #drawerContent>
	<div class="hmf-mt-s hmf-mx-s hmf-mt-md-m hmf-mx-md-m">
		<p class="hmf-header-bold-s hmf-my-xs">Protect Your Purchase</p>
	</div>
	<div class="scroll-content hmf-h-100">
		<div class="hmf-mb-s hmf-mx-s hmf-mx-md-m hmf-mb-md-m">
			@if (shouldShowWarrantyInfo()) {
				<non-merch-common-externals-warranty-info
					[aemContentIdentifier]="aemContentIdentifier()"
					[displayMainTitle]="false"
				>
				</non-merch-common-externals-warranty-info>
			}

			<pdp-component-warranty-plan-selector
				[isError]="warrantyCallState() === 'error'"
				[isLoading]="warrantyCallState() === 'loading'"
				[warranties]="availableWarranties()"
				[(selectedPlanSku)]="selectedPlanSku">
			</pdp-component-warranty-plan-selector>
		</div>
	</div>
	@if (warrantyCallState() !== 'error' && availableWarranties().length) {
		<div class="top-shadow hmf-px-m hmf-py-s hmf-mt-auto hmf-w-100">
			<div>
				<button
					class="hmf-w-100"
					hmf-button
					variant="primary"
					[disabled]="warrantyCallState() === 'loading'"
					(click)="handleSaveSelectionClick()"
					tabindex="0">
					save selection
				</button>
			</div>
		</div>
	}
</ng-template>
